import React, { Component } from 'react';
import { userStatus, envConfig, history } from '../../../_helpers';
import { Loader } from '../../../_components';
import queryString from 'query-string';

const formatDataString = (n) => {
  let data = n.toFixed(3).replace('.', ',').replace(/\d{3}(?=(\d{3})*,)/g, function(s) {
    return '.' + s
  })

  let formatted = data.substr(0, (data.length - 4));
  if ( formatted.length <= 4 ) return formatted.replace('.', '');
  if ( formatted.charAt(0) === '.' ) return formatted.substr(1, formatted.length);

  return formatted;
}

export default class Card extends Component {
  constructor(props) {
    super(props);

    this.state = {
      endpoint: this.props.endpoint,
      domain: '',
      data: 0,
      loaded: false,
      period: this.props.period,
      start: this.props.period.start,
      end: this.props.period.end,
      flag: false,
      isMultiple: false
    }
  }

  async componentDidMount() {
    if ( sessionStorage.getItem('selected_domain') ) {
      if ( this.state.flag ) return;

      let data = await JSON.parse(sessionStorage.getItem('selected_domain'));
      this.listAnalyticsData(data.uuid, this.state.start, this.state.end);
    }
  }

  async componentWillReceiveProps(nextProps) {
    if ( nextProps.period.start === this.state.start && nextProps.period.end === this.state.end ) return;

    await this.setState({
      loaded: false,
      start: nextProps.period.start,
      end: nextProps.period.end,
      period: nextProps.period,
      domain: queryString.parse(history.location.search).domain
    }, () => this.listAnalyticsData(this.state.domain, nextProps.period.start, nextProps.period.end));
  }

  async listAnalyticsData(domain, start, end) {
    const user = userStatus();
    let { endpoint } = this.state;
    
    if ( !domain ) domain = this.state.domain;
    if ( !start ) start = this.state.start;
    if ( !end ) end = this.state.end;

    let url = `${envConfig.ANALYTICS_API_URL}/analytics/${domain}${endpoint}?start=${start.format('YYYY-MM-DD')}&end=${end.format('YYYY-MM-DD')}`;
    let options = {
      method: 'GET',
      headers: { 
        Authorization: `Bearer ${user.bearer_token}`
      }
    }

    let request = await fetch(url, options);

    if ( request.status !== 200 ) return Promise.reject(await request.json());
    let response = await request.json();
    if ( response.data.length === 0 ) response.data = 0;

    if (typeof(response.data) !== "object") {
      return this.setState({data: response.data, loaded: true});
    }

    await this.setState({
      isMultiple: true,
      data: response.data,
      loaded: true
    })
  }

  render() {
    let cardPeriod = `Entre os dias ${this.state.start.format("DD/MM/YYYY")} - ${this.state.end.format("DD/MM/YYYY")}.`;
    
    // switch ( this.props.period ) {
    //   case 1:
    //     cardPeriod = "Últimas 24 horas";
    //     break;
    //   case 90:
    //     cardPeriod = "Todo o período";
    //     break;
    //   default:
    //     cardPeriod = `Últimos ${this.props.period} dias`;
    // }

    return (
      <>
        {
          !this.state.isMultiple ?
            <div className="col" key={this.props.title}>
              {
                this.state.loaded ?
                  <div className="card">
                    <input type="hidden" name="datatocsv" value={`Visualizações de Página: ${formatDataString(this.state.data)}`}/>
                    <div className="content-group">
                      <p className="title">{this.props.title}</p>
                      <p className="counter">{formatDataString(this.state.data)}</p>

                      {
                        this.props.percentage ?
                          <div className="percentage">
                            <span><i className="linearicons-arrow-up"></i>{this.props.percentage}</span> {this.props.pdesc}
                          </div>
                        : <div className="percentage">
                            <span><i className="linearicons-minus"></i>{this.props.percentage}</span> {cardPeriod} {this.props.pdesc}
                          </div>
                      }
                    </div>
                    <div className="icon-group">
                      <div className="icon">
                        <i className={this.props.icon}></i>
                      </div>
                    </div>
                  </div>
                : <Loader className="extra-margin-bottom" />
              }
            </div>
          : <>
            <div className="col" key={this.props.title}>
              {
                this.state.loaded ?
                  <div className="card">
                    <input type="hidden" name="datatocsv" value={`Momentums inativos: ${this.state.data.inactive}`}/>
                    <div className="content-group">
                      <p className="title">{this.props.title}</p>
                      <p className="counter">{this.state.data.inactive}</p>

                      {
                        this.props.percentage ?
                          <div className="percentage">
                            <span><i className="linearicons-arrow-up"></i>{this.props.percentage}</span> {this.props.pdesc}
                          </div>
                        : <div className="percentage">
                            <span><i className="linearicons-minus"></i>{this.props.percentage}</span> {cardPeriod} {this.props.pdesc}
                          </div>
                      }
                    </div>
                    <div className="icon-group">
                      <div className="icon">
                        <i className={this.props.icon}></i>
                      </div>
                    </div>
                  </div>
                : <Loader className="extra-margin-bottom" />
              }
            </div>
            <div className="col" key="Momentums ativos">
              {
                this.state.loaded ?
                  <div className="card">
                    <input type="hidden" name="datatocsv" value={`Momentums ativos: ${this.state.data.active}`}/>
                    <div className="content-group">
                      <p className="title">Momentums ativos</p>
                      <p className="counter">{this.state.data.active}</p>

                      {
                        this.props.percentage ?
                          <div className="percentage">
                            <span><i className="linearicons-arrow-up"></i>{this.props.percentage}</span> {this.props.pdesc}
                          </div>
                        : <div className="percentage">
                            <span><i className="linearicons-minus"></i>{this.props.percentage}</span> {cardPeriod} {this.props.pdesc}
                          </div>
                      }
                    </div>
                    <div className="icon-group">
                      <div className="icon">
                        <i className={this.props.icon}></i>
                      </div>
                    </div>
                  </div>
                : <Loader className="extra-margin-bottom" />
              }
            </div>
          </>
        }
      </>
    )
  }
}